<script lang="ts" setup>
  import { computed, ref, useSlots, watchEffect } from 'vue';
  import { excludeObjectKeys } from '../../../utils';
  import { DialogProps } from './dialog';

  defineOptions({
    name: 'IDialog',
  });
  const props = defineProps(DialogProps);
  const slots = useSlots();

  const visible = ref(false);

  watchEffect(() => {
    visible.value = props.modelValue;
  });

  const attrs = computed(() => excludeObjectKeys(props, ['modelValue']));

  const hasFooter = computed(() => !!slots.footer);
</script>

<template>
  <el-dialog
    v-model="visible"
    v-bind="attrs"
    class="i-dialog"
    :class="{
      'i-dialog__empty_footer': !hasFooter,
    }"
  >
    <template #header>
      <slot v-if="slots.header" name="header" />
    </template>
    <template #default>
      <slot name="default" />
    </template>
    <template #footer>
      <slot v-if="slots.footer" name="footer" />
    </template>
  </el-dialog>
</template>
